import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/internal/operators/tap';
import { ScreeningNote } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { AuthService } from 'src/app/services/auth.service';
import { FilteringService } from 'src/app/services/filtering.service';

@Component({
  selector: 'app-screening-notes',
  templateUrl: './screening-notes.component.html',
  styleUrls: ['./screening-notes.component.less']
})
export class ScreeningNotesComponent {
  @Input() screeningNotes: ScreeningNote[];
  @Input() screeningId: number;
  newNote : ScreeningNote;
  addNewNote : boolean = false;
  savingNote : boolean = false;

  constructor(public auth: AuthService, public filtering: FilteringService, public screening: ScreeningService, public toast: ToastrService) {
    
  }

  addNewSearchNote() : void {
    this.newNote = new ScreeningNote;
    this.newNote.displayed = true;
    this.newNote.noteCategory = 0;
    this.newNote.userId = this.auth.loggedInUser.id;
    this.newNote.screeningId = this.screeningId;
    this.newNote.userName = this.auth.loggedInUser.userName;
    this.newNote.timestamp = new Date();
    this.newNote.id = 0;
    this.screeningNotes.push(this.newNote);
  }

  saveNewNote(note: ScreeningNote) : void {
    this.screening.SaveNewScreeningNote(note).subscribe((res : number) => {
      if(res > 0) {
        note.id = res;
        this.toast.success('Successfully saved note!')
      } else {
        this.toast.error('Failed to save screening note!', '', { closeButton: true, disableTimeOut: true })
      }
      this.savingNote = false;
    },
    error => {
      this.toast.error('Failed to save screening note!', '', { closeButton: true, disableTimeOut: true })
      this.savingNote = false;
    });
  }

  updateScreeningNote(note: ScreeningNote) {
    console.log('updating note: ', note)
    this.screening.UpdateScreeningNote(note).pipe(
      tap(_ => {
        this.toast.success('Note updated.')
      },
      err => {
        this.toast.error('Failed to update screening note!', '', { closeButton: true, disableTimeOut: true })
      },
      () => {

      })
    ).subscribe();
  }

  hideScreeningNote(note: ScreeningNote) {
    this.screening.HideScreeningNote(note).subscribe((res : boolean) => {
      if(res) {
        note.displayed = false;
        this.screeningNotes = this.screeningNotes.filter(n => { return n.displayed });
        this.toast.success('Note successfully removed!');
      } else {
        this.toast.error('Note failed to remove!', '', { disableTimeOut: true, closeButton: true });
      }
    },
    error => {
      this.toast.error('Note failed to remove!', '', { disableTimeOut: true, closeButton: true });
    })
  }

}
